/**
 * Bundles optional add-on variant lines with the main product when add-ons are checked.
 * Uses document capture listeners so we run before the theme's item-entry handler.
 */
(function () {
  function addonInputsForForm(form) {
    if (!form) return [];
    return Array.from(
      document.querySelectorAll("input.item-addon-choice")
    ).filter(function (cb) {
      return cb.form === form;
    });
  }

  function selectedAddons(form) {
    return addonInputsForForm(form).filter(function (cb) {
      return cb.checked && cb.dataset && cb.dataset.variantId;
    });
  }

  function getMainVariantId(form) {
    var fd = new FormData(form);
    var fromForm = fd.get("id");
    if (fromForm) return parseInt(fromForm, 10);
    var input = form.querySelector('input[name="id"], select[name="id"]');
    if (input && input.value) return parseInt(input.value, 10);
    return NaN;
  }

  function buildPayload(form) {
    var mainId = getMainVariantId(form);
    var quantity = Math.max(1, parseInt(new FormData(form).get("quantity") || "1", 10));

    /** Customer-visible notes only on the main product (cart, checkout, order — no bundle ids). */
    var mainProps = {};

    selectedAddons(form).forEach(function (cb) {
      var label = cb.dataset.propertyLabel || cb.dataset.addonTitle || "Add-on";
      var value = cb.dataset.propertyValue || cb.dataset.addonTitle || "Yes";
      var pid = cb.dataset.addonProductId || "";
      var key = label;
      if (mainProps[key] !== undefined) {
        key = pid ? label + " · " + pid : label + " · " + (cb.dataset.variantId || "");
      }
      mainProps[key] = value;
    });

    var mainItem = {
      id: mainId,
      quantity: quantity,
      properties: mainProps,
    };

    var items = [mainItem];

    selectedAddons(form).forEach(function (cb) {
      var vid = parseInt(cb.dataset.variantId, 10);
      if (!vid) return;
      /** Add-on lines: variant + qty only (no line item properties on orders or emails). */
      items.push({
        id: vid,
        quantity: quantity,
      });
    });

    return items;
  }

  function setSubmitBusy(form, busy) {
    var formId = form.id;
    if (formId) {
      document.querySelectorAll('button[form="' + formId + '"][type="submit"]').forEach(function (btn) {
        if (busy) {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-busy", "true");
        } else {
          btn.removeAttribute("disabled");
          btn.removeAttribute("aria-busy");
        }
      });
    }
    Array.from(form.elements)
      .filter(function (el) {
        return el.type === "submit";
      })
      .forEach(function (btn) {
        if (busy) {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-busy", "true");
        } else {
          btn.removeAttribute("disabled");
          btn.removeAttribute("aria-busy");
        }
      });
  }

  function isPaymentButtonClick(event) {
    return event.composedPath().some(function (n) {
      return (
        n &&
        n.classList &&
        typeof n.classList.contains === "function" &&
        n.classList.contains("shopify-payment-button__button")
      );
    });
  }

  function findProductFormFromPath(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.getAttribute) continue;
      if (el.nodeName === "FORM" && el.getAttribute("is") === "item-entry") {
        return el;
      }
    }
    return null;
  }

  function shouldInterceptForm(form) {
    var addonInputs = addonInputsForForm(form);
    if (!addonInputs.length) return false;
    return selectedAddons(form).length > 0;
  }

  async function addBundle(form, redirectToCheckout) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    var mainVariantId = getMainVariantId(form);
    if (!mainVariantId || isNaN(mainVariantId)) {
      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: "Could not read product variant." },
        })
      );
      return;
    }

    var items = buildPayload(form);

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );
    setSubmitBusy(form, true);

    var body = {
      items: items,
      sections: sectionsToBundle.join(","),
      sections_url: "/variants/" + mainVariantId,
    };

    try {
      var response = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(body),
        }
      );

      var responseJson;
      try {
        responseJson = await response.json();
      } catch (parseErr) {
        responseJson = { description: "Invalid response from cart." };
      }

      setSubmitBusy(form, false);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );

      if (!response.ok) {
        form.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error:
                responseJson.description ||
                responseJson.message ||
                "Could not add to cart",
            },
          })
        );
        return;
      }

      if (redirectToCheckout) {
        window.location.href = window.Shopify.routes.root + "checkout";
        return;
      }

      var settings = window.themeVariables && window.themeVariables.settings;
      if (
        settings &&
        (settings.cartType === "page" || settings.pageType === "cart")
      ) {
        window.location.href = window.Shopify.routes.root + "cart";
        return;
      }

      var cartRes = await fetch(window.Shopify.routes.root + "cart.js");
      var cartContent = await cartRes.json();
      cartContent.sections = responseJson.sections;

      form.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items")
              ? responseJson.items
              : [responseJson],
            cart: cartContent,
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );
    } catch (err) {
      setSubmitBusy(form, false);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: err.message || "Network error" },
        })
      );
    }
  }

  function onDocumentSubmit(event) {
    var form = event.target;
    if (!form || form.nodeName !== "FORM") return;
    if (form.getAttribute("is") !== "item-entry") return;
    if (!shouldInterceptForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    addBundle(form, false);
  }

  function onDocumentClick(event) {
    if (!isPaymentButtonClick(event)) return;
    var form = findProductFormFromPath(event);
    if (!form) return;
    if (!shouldInterceptForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    addBundle(form, true);
  }

  document.addEventListener("submit", onDocumentSubmit, true);
  document.addEventListener("click", onDocumentClick, true);
})();
